import script from "./SecurityRoadmap.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityRoadmap.vue?vue&type=script&setup=true&lang=js"

import "./SecurityRoadmap.vue?vue&type=style&index=0&id=29d16aee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d16aee"]])

export default __exports__